interface Props {
  visible: boolean;
}

export function FileDropOverlay({ visible }: Props) {
  if (!visible) return null;
  return (
    <div className="pointer-events-none absolute inset-0 z-10 grid place-items-center border-2 border-dashed border-accent bg-accent/10">
      <div className="rounded-lg border border-panel-border bg-panel/85 px-6 py-4 text-base backdrop-blur">
        Drop an .ifc file to load
      </div>
    </div>
  );
}
